// Where to send someone once they've finished signing up.
//
// Sign-up is register → confirm email (often in another tab) → log in, so a
// query param doesn't survive the trip. An invite link remembers its event
// page here, and the register / confirm-email screens pick it up to bring the
// brand back to the event they were invited to.

const KEY = 't2b.postAuthRedirect';
const TTL_MS = 7 * 24 * 60 * 60 * 1000;

// Only same-site paths: "/event/x", never "//evil.com" or "https://…".
export const safeRedirectPath = (path) =>
  typeof path === 'string' &&
  path.startsWith('/') &&
  !path.startsWith('//') &&
  !path.startsWith('/\\')
    ? path
    : null;

export const rememberPostAuthRedirect = (path) => {
  const safe = safeRedirectPath(path);
  if (!safe) return;
  try {
    localStorage.setItem(KEY, JSON.stringify({ path: safe, at: Date.now() }));
  } catch (e) {
    // Storage blocked — the brand just lands on the homepage instead.
  }
};

export const peekPostAuthRedirect = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { path, at } = JSON.parse(raw);
    if (!at || Date.now() - at > TTL_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return safeRedirectPath(path);
  } catch (e) {
    return null;
  }
};

export const takePostAuthRedirect = () => {
  const path = peekPostAuthRedirect();
  try {
    localStorage.removeItem(KEY);
  } catch (e) {
    // ignore
  }
  return path;
};
